module.exports = __webpack_public_path__ + "static/media/menu-routines.8615b959.svg";